export function useBcd() {
  function bcdByteToDecString(bcd: number): string {
    const byte = bcd.toString(16);
    return byte.match(/\D/) ? "?" : byte;
  }

  function bcdWord16ToDecArray(bcd: number): string[] {
    const upperByte = (bcd >> 8) & 0xff;
    const lowerByte = bcd & 0xff;
    return [bcdByteToDecString(upperByte), bcdByteToDecString(lowerByte)];
  }

  function bcdWord32ToDecArray(bcd: number): string[] {
    const upperWord = (bcd >> 16) & 0xffff;
    const lowerWord = bcd & 0xffff;
    return [
      ...bcdWord16ToDecArray(upperWord),
      ...bcdWord16ToDecArray(lowerWord),
    ];
  }

  function decArrayToBcdWord32(decArray: string[]): number {
    return decArray.reduce((acc, next) => {
      return (acc << 8) + Number(parseInt(next, 16));
    }, 0);
  }

  function bcdWord32ToVersionString(bcd: number): string {
    return decArrayToVersionString(bcdWord32ToDecArray(bcd));
  }

  function bcdArrayToVersionString(bcdArray: number[]): string {
    return decArrayToVersionString(bcdArray.map(bcdByteToDecString));
  }

  function decArrayToVersionString(decArray: string[]): string {
    return decArray.join(".");
  }

  function versionStringToDecArray(versionString: string): string[] {
    return versionString.split(".");
  }

  return {
    bcdByteToDecString,
    bcdWord16ToDecArray,
    bcdWord32ToDecArray,
    decArrayToBcdWord32,
    bcdWord32ToVersionString,
    bcdArrayToVersionString,
    decArrayToVersionString,
    versionStringToDecArray,
  };
}
